import styled from "styled-components";
const UserHeader = styled.div`
  display: flex;
  align-items: center;

  justify-content: center;

  button {
    height: 60%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
export default UserHeader;
